import { Grid, styled } from "@mui/material";
import { transientOptions } from "../../styles/theme";

const GridWithMargin = styled(Grid, transientOptions)`
  margin: ${({ __margin }) => __margin ?? "0"};
`;

export default GridWithMargin;
